// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__4vxfs","modalFooterButton":"ModalNotes_modalFooterButton__2d5ZP"};